// This component is currenly not in use by decision of 
// Harm, Jesse and Nimrod becase we think it unnnessiary and causes the page to be to much and be a bit overwelming.
// It can be anabled and used if needed for that reason we want to keep this


import { useRef, useEffect } from "react";

export function ScreencastWindow({ src, onClose }) {
  const popupRef = useRef(null);
  const imgRef = useRef(null);
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    const popup = window.open(
      "",
      "DatalayerGuard",
      "width=640,height=480"
    );

    popup.document.title = "Datalayer guard live stream";
    popup.document.body.style.background = "#000";
    popup.document.body.style.height = "100vh";

    const img = popup.document.createElement("img");
    img.alt = "DatalayerGuard";
    img.style.maxWidth = "100%";
    img.style.maxHeight = "100%";
    img.style.objectFit = "contain";
    popup.document.body.appendChild(img);
    imgRef.current = img;
    popupRef.current = popup;

    const onUnload = () => onCloseRef.current?.();
    popup.addEventListener("beforeunload", onUnload);

    return () => {
      popup.removeEventListener("beforeunload", onUnload);
      if (!popup.closed) popup.close();
    };
  }, []);

  useEffect(() => {
    if (imgRef.current && src) {
      imgRef.current.src = src;
    }
  }, [src]);

  return null;
}
